import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys =
  | 'USER_HAK_AKSES'
  | 'USER_HAK_AKSES_LIST'
  | 'USER_HAK_AKSES_ADD'
  | 'USER_HAK_AKSES_DETAIL'
  | 'USER_HAK_AKSES_EDIT'

export const HakAksesScreen: Record<TKeys, ScreenProp> = {
  USER_HAK_AKSES: {
    PATH: '/user/permission',
    TITLE: 'Hak Akses',
    TITLE_ALT: 'Hak Akses',
  },
  USER_HAK_AKSES_LIST: {
    PATH: '/user/permission/list',
    TITLE: 'Hak Akses',
    TITLE_ALT: 'Hak Akses',
    PERMISSION: [EPermissions.PERMISSION_READ],
  },
  USER_HAK_AKSES_ADD: {
    PATH: '/user/permission/add',
    TITLE: 'Buat Hak Akses',
    TITLE_ALT: 'Buat Hak Akses',
    PERMISSION: [EPermissions.PERMISSION_CREATE],
  },
  USER_HAK_AKSES_DETAIL: {
    PATH: '/user/permission/detail/:id',
    TITLE: 'Detail Hak Akses',
    TITLE_ALT: 'Detail Hak Akses',
    PERMISSION: [EPermissions.PERMISSION_READ],
  },
  USER_HAK_AKSES_EDIT: {
    PATH: '/user/permission/edit/:id',
    TITLE: 'Edit Hak Akses',
    TITLE_ALT: 'Edit Hak Akses',
    PERMISSION: [EPermissions.PERMISSION_UPDATE],
  },
}
